import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContentText from '@material-ui/core/DialogContentText';

import translation from '../../../translation/translation';

const useStyles = makeStyles(() => ({
  alignRight: {
    textAlign: 'right',
    marginTop: 24,
    marginBottom: 24
  }
}));

function ManageCompanyTenant(props) {
  const { closeDialogFunction, manageCompanyTenant, reloadListFunction, resource } = props;

  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);

  function handleSubmit() {
    if (!resource || !resource.id) return;

    setLoading(true);

    manageCompanyTenant(
      resource.id,
      !resource.tenant,
      () => {
        setLoading(false);
        closeDialogFunction();
        reloadListFunction();
      },
      () => {
        setLoading(false);
      }
    );
  }

  return (
    <div className="ManageCompanyFlag">
      {resource && (
        <DialogContentText>
          {resource.tenant
            ? translation().core.list.dialogs.custom_list_actions.manage_company_tenant
                .description_remove
            : translation().core.list.dialogs.custom_list_actions.manage_company_tenant
                .description_add}
        </DialogContentText>
      )}
      <div>
        {resource && (
          <div className={classes.alignRight}>
            <Button disabled={isLoading} variant="contained" onClick={handleSubmit} color="primary">
              {resource.tenant
                ? translation().core.list.dialogs.custom_list_actions.manage_company_tenant.buttons
                    .remove
                : translation().core.list.dialogs.custom_list_actions.manage_company_tenant.buttons
                    .add}
            </Button>
          </div>
        )}
        {isLoading && (
          <div className="loader-wpr">
            <CircularProgress color="primary" size={25} />
            <p>
              {
                translation().core.list.dialogs.custom_list_actions.manage_company_tenant
                  .loading_text
              }
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

ManageCompanyTenant.propTypes = {
  closeDialogFunction: PropTypes.func.isRequired,
  manageCompanyTenant: PropTypes.func.isRequired,
  reloadListFunction: PropTypes.func.isRequired,
  resource: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    flag: PropTypes.bool
  })
};

export default ManageCompanyTenant;
